var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"organizationMapBox"}},[_c('div',{attrs:{"id":"organizationMap"}}),_c('el-button',{staticStyle:{"margin-top":"10px"},on:{"click":_vm.reDraw}},[_vm._v("重绘区域范围")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }